// extracted by mini-css-extract-plugin
module.exports = {"references-card":"styles-module__references-card___3pA5B"};